import { render } from "./DigilamVsLitholamManufacturing.vue?vue&type=template&id=3da31921&scoped=true"
const script = {}

import "./DigilamVsLitholamManufacturing.vue?vue&type=style&index=0&id=3da31921&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da31921"]])

export default __exports__